<template>
  <div>
    <b-row class="toolbar-ptc">
      <b-col></b-col>
      <b-col class="text-center title">情報分析 / 地區訂購餐點查詢</b-col>
      <b-col>
        <div class="text-right">
        </div>
      </b-col>
    </b-row>
    <div id="func-content">
        <b-card class="bg-default-card">
          <div class="row">
            <div class="col-lg-12">
              <div class="p-4 box-shadow">
              <div class="row">
                <label class="control-label col-md-2 mt-2 text-right">品牌：</label>
                <div class="col-md-3">
                      <select
                        id="queryBrandsCode"
                        name="queryBrandsCode"
                        class="form-control col-md-9"
                        v-model="queryBrandsCode"
                        @change="getAllProductAttributes();getpost()"
                      >
                      <option
                        v-for="x in selectListBrands"
                        v-bind:value="x.Code"
                        :key="x.Code"
                      >{{x.Text}}</option>
                      </select>
                </div>
              </div>
              <div class="row">
                  <label class="control-label col-md-2 mt-2 text-right">訂購區間：</label>
                  <div class="col-md-3">
                    <input type="date" class="form-control" v-model="sdate">
                  </div>
                  <label class="mt-2">至</label>
                  <div class="col-md-3">
                    <input type="date" class="form-control" v-model="edate">
                  </div>
              </div>
              <div class="row">
                <label class="control-label col-md-2 mt-2 text-right">地區：</label>
                <div class="col-md-3">
                  <select class="form-control col-md-9" id="city" name="city" v-model="city" @change="cityChange">
                    <option v-bind:value="''" :key="''">全部</option>
                    <option v-for="x in citylist" v-bind:value="x.City" :key="x.City">{{x.City}}</option>
                  </select>
                </div>
                <label class="control-label col-md-2 mt-2 text-right">門市：</label>
                <div class="col-md-4">
                  <multiselect v-model="store" :options="storelist" :multiple="false" :custom-label="nameWithLang" placeholder="請選擇" label="Name" track-by="Name" :show-labels="false">
                    <span slot="noResult">查無資料</span>
                  </multiselect>
                </div>
              </div>
              <div class="row">
                <label class="control-label col-md-2 mt-2 text-right">單品/套餐：</label>
                <div class="col-md-3">
                  <select class="form-control col-md-9" id="producttype" name="producttype" v-model="producttype">
                    <option v-bind:value="''" :key="''">全部</option>
                    <option v-bind:value="'1'" :key="'1'">單品</option>
                    <option v-bind:value="'4'" :key="'4'">套餐</option>
                  </select>
                </div>
                <label class="control-label col-md-2 mt-2 text-right">含套餐內品項：</label>
                <div class="col-md-3">
                  <b-form-radio-group class="mt-2" v-model="addincombo" v-if="producttype == '1'">
                  <b-form-radio v-bind:value="1" :key="1">是</b-form-radio>
                  <b-form-radio v-bind:value="2" :key="2">否</b-form-radio>
                  </b-form-radio-group>
                </div>
              </div>
              <div class="row">
                <label class="control-label col-md-2 mt-2 text-right">商品分類：</label>
                <div class="col-md-3">
                  <select class="form-control col-md-9" id="attribute" name="attribute" v-model="attribute" v-if="producttype == '1'">
                    <option v-bind:value="''" :key="''">全部</option>
                    <option v-for="x in productAttributes" v-bind:value="x.Code" :key="x.Code">{{x.Name}}</option>
                  </select>
                </div>
                <div class="col-lg-6 mt-2 text-right">
                    <button type="button" class="btn btn-warning text-white" @click="getinformation(1)">查詢</button>
                </div>
              </div>
              </div>
            </div>
          </div>
        </b-card>
      <b-card class="bg-default-card">
        <div class="row">
          <div class="col-lg-12">
            <table id="mytable" class="table table-bordred table-striped">
              <thead>
                <tr>
                  <th width="60px">排序</th>
                  <th>品項</th>
                  <th>代碼</th>
                  <th>類別</th>
                  <th>商品分類</th>
                  <th>訂購數量</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(x,index) in coupon" :key="x.ProductCode">
                  <td>
                              <img class="icon_img" v-if="index==0 && currentPage == 1" src="../../../assets/gold_one.png" />
                              <img class="icon_img" v-else-if="index==1 && currentPage == 1" src="../../../assets/silver_two.png" />
                              <img class="icon_img" v-else-if="index==2 && currentPage == 1" src="../../../assets/copper_three.png" />
                              <span class="font-center" v-else>{{((currentPage-1)*perpage+index+1)}}</span>
                  </td>
                  <td>{{x.ProductName}}</td>
                  <td>{{x.ProductCode}}</td>
                  <td>{{x.ProductType}}</td>
                  <td>{{x.Attribute}}</td>
                  <td>{{x.Count}}</td>
                </tr>
              </tbody>
            </table>
            <div class="row" style="padding: 0 1rem">
              <b-pagination size="md" :total-rows="count" v-model="currentPage" :per-page="perpage" @change="getinformation"></b-pagination>
              <label style="margin:8px">{{startRowNum}}到{{endRowNum}}，總共 {{count}}筆</label>
            </div>
          </div>
        </div>
      </b-card>
    </div>
  </div>
</template>
<script>
import miniToastr from 'mini-toastr'
import axios from 'axios'
import {API_URL} from '../../../store/root.js'
import { getFunctionPermission } from '@/js/LoginUserFunction.js'
import Multiselect from 'vue-multiselect'
miniToastr.init()
export default {
  components: {
    Multiselect
  },
  data () {
    return {
      citylist: [], // 地區類別下拉
      productAttributes: [],
      storelist: [{ ID: 0, Code: '', Name: '' }],
      selectListBrands: [], // 品牌下拉選單

      queryBrandsCode: 'MWD',
      sdate: '',
      edate: '',
      city: '', // 地區
      store: { ID: 0, Code: '', Name: '' }, // 門市
      producttype: '', // 單品/套餐
      addincombo: 1, // 單品含套餐內品項
      attribute: '', // 商品類別

      coupon: [],
      currentPage: 1,
      perpage: 20,
      count: 0,
      startRowNum: 0,
      endRowNum: 0
    }
  },
  created () {
    this.setdate()
    this.getpost()
    this.getAllProductAttributes()
    this.getinformation(1)
    this.FunctionPermission = getFunctionPermission('F26') // 功能權限 帶入功能代碼
    if (this.FunctionPermission < 1) {
      this.$router.push({name: 'name'})
    }
    this.querySelectListBrands()
  },
  methods: {
    onReady (instance) {
      this.instances.push(instance)
    },
    getinformation (currentPage) {
      if (this.store == null) {
        this.store = { ID: 0, Code: '', Name: '' }
      }
      if (this.sdate === '' || this.edate === '' || this.sdate > this.edate) {
        miniToastr.error('請選擇正確的效期區間')
        return
      }
      if (this.producttype != '1') {
        this.attribute = ''
      }
      this.$parent.Loading = true
      return axios.post(API_URL + '/web/information/areaOrder', {
        brandCode: this.queryBrandsCode,
        sdate: this.sdate,
        edate: this.edate,
        city: this.city,
        store: this.store.ID,
        producttype: this.producttype,
        addincombo: this.addincombo,
        attribute: this.attribute,
        toPage: currentPage,
        perPage: this.perpage
      })
        .then((response) => {
          if (response.data.result === '0000') {
            this.coupon = response.data.data
            this.currentPage = currentPage
            this.count = (response.data.count === undefined) ? 0 : response.data.count
            this.startRowNum = (response.data.count === undefined || response.data.count === 0) ? 0 : this.perpage * (this.currentPage - 1) + 1
            this.endRowNum = (response.data.count === undefined || response.data.count === 0) ? 0 : (this.perpage > response.data.count) ? response.data.count : (this.currentPage * this.perpage) >= response.data.count ? response.data.count : this.currentPage * this.perpage
            this.$store.commit('TOKEN', response.data.jwt)
          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
          } else {
            miniToastr.error(response.data.message, '查詢失敗')
          }
          this.$parent.Loading = false
        })
        .catch((error) => {
          miniToastr.error(error.message, '查詢失敗')
          this.$parent.Loading = false
        })
    },
    setdate () {
      var today = new Date()
      var todaymon = today.getMonth() + 1
      if (todaymon < 10) {
        todaymon = '0' + todaymon
      }

      var date = new Date()
      date.setMonth(date.getMonth())
      var year = date.getFullYear()
      var mon = date.getMonth() + 1
      var day = date.getDate()

      if (mon < 10) {
        mon = '0' + mon
      }
      if (day < 10) {
        day = '0' + day
      }
      this.sdate = year + '-' + mon + '-01'
      this.edate = year + '-' + todaymon + '-' + day
    },
    getpost () {
      this.$parent.Loading = true
      return axios.post(API_URL + '/web/shopping/getallstoresTowLevel/v1', {
        brandCode: [this.queryBrandsCode],
      })
        .then((response) => {
          if (response.data.result === '0000') {
            this.citylist = response.data.data
            this.cityChange()
            this.$store.commit('TOKEN', response.data.jwt)
          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
          } else {
            miniToastr.error(response.data.message, '資料讀取異常')
            console.log(response.data.message)
          }
          this.$parent.Loading = false
        })
        .catch((error) => {
          console.log('CATCH')
          console.log(error)
          miniToastr.error(error.message, '資料讀取異常')
          this.$parent.Loading = false
        })
    },
    cityChange () {
      var plist = []
      var city = this.city
      if (this.city === '') {
        this.citylist.forEach(function (arrRole, Index) {
          arrRole.Stores.forEach(function (arrRole1, Index1) {
            plist.push(arrRole1)
          })
        })
      } else {
        this.citylist.forEach(function (arrRole, Index) {
          if (arrRole.City === city) {
            arrRole.Stores.forEach(function (arrRole1, Index1) {
              plist.push(arrRole1)
            })
          }
        })
      }
      this.storelist = plist
      this.store = ''
    },
    getAllProductAttributes () {
      this.$parent.Loading = true
      return axios.post(API_URL + '/web/shopping/getallproductAttributes/v1', {
        status: 1,
        brandCode: this.queryBrandsCode,
      })
        .then((response) => {
          this.$store.commit('TOKEN', response.data.jwt)
          this.$parent.Loading = false

          if (response.data.result === '0000') {
            this.productAttributes = response.data.data
          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
          } else {
            miniToastr.error(response.data.message, '商品資料讀取異常')
            console.log(response.data.message)
          }
        })
        .catch((error) => {
          this.$parent.Loading = false
          miniToastr.error(error, '商品資料讀取異常')
          console.log(error)
        })
    },
    nameWithLang ({ Code, Name }) {
      return `${Code} — ${Name}`
    },
    querySelectListBrands() {
      //品牌下拉選單
      axios
        .post(API_URL + "/web/brands/v1", {
          all: false,
          order: true
        })
        .then(response => {
          this.selectListBrands = response.data.data;
          this.$parent.Loading = false;
        })
        .catch(error => {
          this.selectListBrands = [];
          this.$parent.Loading = false;
          miniToastr.error(error, "資料讀取異常");
          console.log(error);
        });
    },
  }

}
</script>
<style scoped>
  .box-shadow {
    box-shadow: 0px 0px 1px 1px #cfcfcf;
  }
  .font_text {
    font-size: 19px;
    margin: 6px 0 7px;
  }
  .icon_img {
    height: 100%;
    padding: 0;
    margin: -2px;
  }
  #mytable > tbody > tr > td {
    vertical-align: middle;
    /* text-align: center; */
    height: 59px;
 }

</style>



// WEBPACK FOOTER //
// src/pages/information/areaOrder/List.vue